import { motion } from "framer-motion";
import { Archive, HeartHandshake, Wind, Home, ArrowUpRight, Check } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId } from "./data";

const SERVICES = [
  { icon: Archive, title: "Messie-lakás takarítás & teljes körű lomtalanítás", sub: "Gyűjtögető életmód után", points: ["Teljes kiürítés és elszállítás", "Értéktárgyak szétválogatása igény szerint", "Mélytakarítás és fertőtlenítés"] },
  { icon: HeartHandshake, title: "Haláleset és trauma utáni kegyeleti fertőtlenítés", sub: "Tapintatos, csendes munkavégzés", points: ["Biológiai szennyeződés eltávolítása", "Fertőtlenítés és szagmentesítés", "Együttérző, diszkrét kapcsolattartás"] },
  { icon: Wind, title: "Ózonos légtérfertőtlenítés és szagmentesítés", sub: "Dohányfüst, elhalálozás, penész", points: ["Ózongenerátoros kezelés", "Szagok megszüntetése a forrásnál", "Lakható, friss légtér"] },
  { icon: Home, title: "Súlyosan szennyezett, elhanyagolt ingatlanok helyreállítása", sub: "Teljes higiéniai helyreállítás", points: ["Bérlők távozása utáni állapot", "Örökölt, régóta zárt ingatlanok", "Kiadható, eladható állapot"] },
];

export const Services = () => (
  <section id="szolgaltatasok" data-testid="services-section" className="relative bg-[var(--navy)] py-20 text-white sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <Eyebrow light>Szolgáltatások</Eyebrow>
              <h2 className="font-display mt-5 text-3xl font-black leading-[1.05] tracking-tight sm:text-5xl">Amit elvégzünk – az elejétől a végéig.</h2>
              <p className="mt-5 text-base leading-relaxed text-white/80 sm:text-lg">Egy csapat, egy kapcsolattartó, egy fix ár. Önnek nem kell jelen lennie a munkavégzésnél.</p>
            </Reveal>
            <Reveal delay={0.1} className="mt-8 overflow-hidden rounded-[22px]">
              <img src="/img/gear_detail.webp" alt="Professzionális védőfelszerelés: munkaruha, maszk, kesztyű, fertőtlenítő" className="aspect-[4/3] w-full object-cover" loading="lazy" />
            </Reveal>
          </div>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:col-span-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 2) * 0.08}>
              <motion.article
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                data-testid={`service-card-${i + 1}`}
                className="group flex h-full flex-col rounded-[24px] border border-white/10 bg-white/[0.04] p-7 transition-colors duration-500 hover:border-white/25 hover:bg-white/[0.08]"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-[var(--navy)] transition-colors duration-500 group-hover:bg-[var(--crimson)] group-hover:text-white">
                    <s.icon className="h-6 w-6" />
                  </span>
                  <span className="font-display text-sm font-bold text-white/60">0{i + 1}</span>
                </div>
                <h3 className="font-display mt-7 text-xl font-extrabold leading-snug sm:text-[1.4rem]">{s.title}</h3>
                <p className="mt-1.5 text-sm font-semibold text-[#FF9A85]">{s.sub}</p>
                <ul className="mt-5 space-y-2.5">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-2.5 text-[15px] text-white/85">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-white" /> {p}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => scrollToId("ajanlat")}
                  data-testid={`service-cta-${i + 1}`}
                  className="mt-auto inline-flex items-center gap-1.5 pt-7 text-sm font-bold text-white underline-offset-4 hover:underline"
                >
                  Ajánlatot kérek <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </button>
              </motion.article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
